import React from 'react'
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import PopInRightPanel from '../components/PopInRightPanel';
import CustomerTable from '../components/CustomerTable';
import OpportunityTable from '../components/OpportunityTable';
import SmallDataCard from '../components/SmallDataCard';
import GraphCard from '../components/GraphCard';
import TasksCompleted from '../components/TasksCompleted';
import TasksTimelines from '../components/TasksTimelines';

let timeprops = {
  color:"dark",
  icon:"schedule",
  measure:"Time Saved",
  sign:"",
  savings: "37",
  units: "mins",
  footersavings: "10%",
  since: " than last week"
  }

let moneyprops = {
  color:"primary",
  icon:"money",
  measure:"Money Saved",
  sign:"£",
  savings: "245",
  units:"GBP",
  footersavings: "67%",
  since: " than last month"
  }

let esgprops = {
  color:"success",
  icon:"language",
  measure:"Carbon Footprint",
  sign: "",
  savings: "3462",
  units:"units",
  footersavings: "17%",
  since: " than yesterday"
  }

let effortprops = {
  color:"info",
  icon:"mail",
  measure:"E-Mails Reduced",
  sign: "",
  savings: "45",
  units:"",
  footersavings: "47%",
  since: " than yesterday"
  }

  let financialgraphprops = {
    color:"primary",
    myid:"1",
    thetitle:"Financial Improvement",
    subtitle:"Last Week",
    alttext: "Cost Saves",
    labels:'["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]',
    data: "[50, 20, 10, 22, 50, 10, 40, 40, 41]",
    footer: " campaign sent 2 days ago"
    }
  
  let esggraphprops = {
    color:"success",
    myid:"2",
    thetitle:"ESG Improvement",
    subtitle:"Last Year",
    alttext: "CO2 Saves",
    labels:'["M", "T", "W", "T", "F", "S", "S"]',
    data: "[50, 40, 300, 320, 500, 350, 200, 230, 500]",
    footer: " updated 4 mins ago"
    }

  let mentalgraphprops = {
    color:"dark",
    myid:"3",
    thetitle:"Mental Health Improvement",
    subtitle:"Last Month",
    alttext: "Time Saves",
    labels:'["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]',
    data: "[50, 40, 300, 220, 500, 250, 400, 230, 500]",
    footer: " just updated"
    }

function Dashboard() {
  return (
    <>
    <main className="main-content border-radius-lg ">
    <NavBar/>  
    <div className="container-fluid py-4">
    <div className="row">
      <SmallDataCard {...timeprops} />
      <SmallDataCard {...moneyprops} />
      <SmallDataCard {...esgprops} />
      <SmallDataCard {...effortprops} />
    </div>
    </div>
    <div className="row mt-4">
      <GraphCard {...financialgraphprops} />
      <GraphCard {...esggraphprops} />
      <GraphCard {...mentalgraphprops} />
    </div>
    <div className="row mb-4">
    <TasksCompleted/>
    <TasksTimelines/>
    </div>
    <CustomerTable/>
    <OpportunityTable/>
    <Footer/>
    </main>
    <PopInRightPanel/>
    </>
  )
}

export default Dashboard
